import { Box, Typography } from '@mui/material';

/**
 * 훈련 상세 공통 정보 필드 (라벨 + 값)
 * 기본 정보 영역에서 사용
 */
const TrainingDetailInfoField = ({ label, value }) => (
  <Box>
    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 500 }}>
      {value || '-'}
    </Typography>
  </Box>
);

export default TrainingDetailInfoField;
